import type {FeatureCollection, MultiPolygon} from 'geojson';

export const getGeoJsonFromBoundary = (boundary: MultiPolygon): FeatureCollection => {
  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: boundary,
        properties: {},
      },
    ],
  };
};
